module.exports = __webpack_public_path__ + "static/media/buildingConstruction18.ec930d9c.jpg";